import { MakeCall } from './createMakeCall';
import { Gender } from './types/Gender';
import { User } from './types/User';

export interface Payload {
  firstName: string;
  lastName?: string;
  email: string;
  password?: string;
  password2?: string;
  phone?: string;
  phoneCountryCode?: string;
  nationality?: string;
  gender?: Gender;
  study?: string;
  work?: string;
  description?: string;
  location?: string;
  smoker?: string;
  enableSMSNotifications?: boolean;
  spokenLanguages?: string;
  lang?: string;
  notificationLang?: string;
  birthDay?: number;
  birthMonth?: number;
  birthYear?: number;
  originUniId?: number;
}

const register = (makeCall: MakeCall) => (data: Payload) =>
  makeCall<User>('POST', `/api/v2/user`, { data });

export { register };
